// Inner imports
import { WIDGET_ACTION_BUTTONS_HOOKS } from "./constants";

export const useWidgetActionButtons = (
  props: Widget.ChartProps,
): Widget.ActionButton[] => WIDGET_ACTION_BUTTONS_HOOKS[props.widgetId](props);
